export function getSecondsFromRunningTimeString(runningTime: string) {
    const [hours, minutes, seconds = '00'] = runningTime.split(':');

    return [
        parseInt(hours || '00') * 60 * 60,
        parseInt(minutes || '00') * 60,
        parseInt(seconds),
    ].reduce((total, value) => value + total, 0);
}
